import { pushSse } from './parseSse';

export async function askSupport({ apiUrl, token, body, onEvent, signal }) {
    const response = await fetch(`${apiUrl.replace(/\/$/, '')}/v1/chat`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'text/event-stream',
        },
        body: JSON.stringify(body),
        signal,
    });
    if (!response.ok || !response.body) {
        const error = new Error('support_request_failed');
        error.status = response.status;
        throw error;
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let pending = '';
    while (true) {
        const { value, done } = await reader.read();
        if (done) {
            break;
        }
        pending = pushSse(pending, decoder.decode(value, { stream: true }), onEvent);
    }
    pending = pushSse(pending, decoder.decode(), onEvent);
    if (pending.trim()) {
        pushSse(`${pending}\n\n`, '', onEvent);
    }
}
